export const getTmtFaceHours = (hours) => {
  return hours.split(':')[0];
};

export const getTmtFaceMin = (min) => {
  return min.split(':')[1];
};

export const getTmtSupplementalHours = (hours) => {
  return hours.split(':')[0];
};

export const getTmtSupplementalMin = (min) => {
  return min.split(':')[1];
};
